<section class="section section--additionalInformation">
  <div class="container">
    <div class="wrapper">
      <div class="content fadeinright animation-duration-300">
        <div class="content__main">
          <article class="mainInfo pb-35">
            <h1 class="pb-10">Información personal</h1>
            <p>{{ 'La siguiente información es necesaria para evaluar tu solicitud de crédito.' | termReplace }}</p>
          </article>

          <article class="form additionalInformation">
            <div class="form__groups pb-10" *ngFor="let groupedField of groupedFields">
              <div class="subtitle mb-25">
                <h2>{{groupedField.title}}</h2>
              </div>
              <div class="form__items">
                <div class="form__item mb-30" *ngFor="let field of groupedField.fields">

                  <!-- PROVINCIA / DROPDOWN LEVEL 1 -->
                  <app-sales-additional-information-field-dropdown
                    variant="v3"
                    [field]="field"
                    [groupedField]="groupedField.fields"
                    [form]="form"
                    (saveEvent)="saveDropDown($event, field)"
                    *ngIf="field.type === additionalFieldTypes['dropdown-level1']">
                  </app-sales-additional-information-field-dropdown>

                  <!-- DISTRITO / DROPDOWN LEVEL 2 -->
                  <app-sales-additional-information-field-dropdown
                    variant="v3"
                    [field]="field"
                    [groupedField]="groupedField.fields"
                    [form]="form"
                    [filter]="dropdownLevel1Filter"
                    (saveEvent)="saveDropDown($event, field)"
                    *ngIf="field.type === additionalFieldTypes['dropdown-level2']">
                  </app-sales-additional-information-field-dropdown>

                  <!-- CORREGIMIENTO / DROPDOWN LEVEL 3 -->
                  <app-sales-additional-information-field-dropdown
                    variant="v3"
                    [field]="field"
                    [groupedField]="groupedField.fields"
                    [form]="form"
                    [filter]="dropdownLevel2Filter"
                    (saveEvent)="saveDropDown($event, field)"
                    *ngIf="field.type === additionalFieldTypes['dropdown-level3']">
                  </app-sales-additional-information-field-dropdown>

                  <!-- DIRECCIÓN, NOMBRES Y APELLIDOS / STRING -->
                  <app-sales-additional-information-field-string
                    variant="v3"
                    [form]="form"
                    [field]="field"
                    (saveEvent)="save($event)"
                    *ngIf="field.type === additionalFieldTypes['string']">
                  </app-sales-additional-information-field-string>

                  <!-- TELÉFONO ADICIONAL, TELÉFONOS / PHONE -->
                  <app-sales-additional-information-field-phone
                    variant="v3"
                    [form]="form"
                    [field]="field"
                    (saveEvent)="save($event)"
                    *ngIf="field.type == additionalFieldTypes['phone']">
                  </app-sales-additional-information-field-phone>

                  <!-- SALARIO, SITUACIÓN LABORAL / RADIO -->
                  <app-sales-additional-information-field-radio
                    variant="v3"
                    [form]="form"
                    [field]="field"
                    (saveEvent)="save($event)"
                    *ngIf="field.type == additionalFieldTypes['radio']">
                  </app-sales-additional-information-field-radio>

                </div>
              </div>
            </div>
          </article>
        </div>

        <div class="content__footer">
          <button pButton pRipple label="Continuar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" [loading]="false" [disabled]="form.invalid || form.pending" (click)="onNextStep()"></button>
        </div>
      </div>
    </div>
  </div>
</section>
